import type {ChallengeResult, ProgressCallback, WorkerResultData} from "../../types";

export async function doProofOfWork(
    request: ChallengeResult,
    startNonce: string,
    progressCallback: ProgressCallback,
    signal: AbortSignal,
): Promise<WorkerResultData> {
    if (import.meta.env.MODE != "sw" && typeof Worker === 'function') {
        const module = await import('./work-worker');
        return await module.doProofOfWorkWithWorker(request, startNonce, progressCallback, signal);
    } else {
        const module = await import('./work-inline');
        return await module.doProofOfWorkInMainThread(request, startNonce, progressCallback, signal);
    }
}
